import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    vehicleId: yup.string().required("Vehicle Number is required"),
    task: yup.string().required("Task is required"),
    startTime: yup.string().required("Starting Date & Time is required"),
    endTime: yup.string().required("End Date & Time is required"),
    isImmediate: yup.boolean(),
    bookingId: yup.string().required("Booking ID is required"),
    tripId: yup.string().required("Trip ID is required"),
    notes: yup.string().optional().nullable(),
});

